import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#88AB8E",
    },
    secondary: {
      main: "#AFC8AD",
    },
    background: {
      default: "#ece3ce",
    },
    text: {
      primary: "#88AB8E",
      secondary: "#AFC8AD",
    },
  },
});

export default theme;
